export default __webpack_public_path__ + "static/media/Time.9f607afd.svg";